import { render, staticRenderFns } from "./Subcontractdata.vue?vue&type=template&id=1f989535&scoped=true"
import script from "./Subcontractdata.vue?vue&type=script&lang=js"
export * from "./Subcontractdata.vue?vue&type=script&lang=js"
import style0 from "./Subcontractdata.vue?vue&type=style&index=0&id=1f989535&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f989535",
  null
  
)

export default component.exports